import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'Details',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
    GoogleMapComp: require('../../../../components/maps/gMapLocation.vue').default,
    MapLocationComp: require('../../../../components/maps/mapLocation.vue').default,
    TimePickerComp: require('../../../../customcontrols/timePicker.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      selectedDate: null,
      problemLogDate: null,
      problemLogTime: null,
      problemLogDateTime: '',
      complainTypes: [],
      complainType: { text: '', value: '' },
      groupCodes: [],
      groupCode: { text: '', value: '' },
      problemStreetAddresses: [],
      problemStreetAddress: { text: '', value: '' },
      problemStreets: [],
      problemStreet: { text: '', value: '' },
      serviceTypes: [],
      serviceType: { text: '', value: '' },
      serviceTypeToStation: [],
      stations: [],
      stationId: -1,
      station: { text: '', value: '' },
      substations: [],
      substationId: -1,
      substation: { text: '', value: '' },
      allSubstations: [],
      towns: [],
      town: { text: '', value: '' },
      allTownships: [],
      townships: [],
      showcompleteTownshipsList: false,
      township: { text: '', value: '' },
      settlements: [],
      settlement: { text: '', value: '' },
      bOnValidate: false,
      message: '',
      gMapData: {
        gMapPosition: { lat: 0, lng: 0 },
        gMapPositionStart: { lat: 0, lng: 0 },
        gMapPositionMove: { lat: 0, lng: 0 },
        markerTitle: this.$t('messages.MarkerTitle'),
        infoContent: '',
        infoWindowPos: null,
        infoWinOpen: false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -50
          }
        },
        bDraggable: true,
        bClickable: true,
        bEditLocation: false,
        unwatchTown: null,
      },
    }
  },
  validations: {
    complainTypeValue: {
      required
    },
    serviceTypeValue: {
      required
    },
    elementValue: {
      required
    },
    groupCodeValue: {
      required
    },
  },
  computed: {
    gMapDialog: function () {
      return this.gMapData.bEditLocation;
    },
    serviceTypeDisabled: function () {
      return this.dataObj.readOnly || this.dataObj.appData.employeeServiceTypeId > 0;
    },
  },
  watch: {
    stationId: function (value) {
      this.station = this.stations.filter(s => s.value == value)[0];
    },
    substationId: function (value) {
      this.substation = this.substations.filter(s => s.value == value)[0];
    },
    settlement: function (value) {
      if (!value)
        return;
      this.dataObj.appData.settlementId = value.value;
    },
    problemStreet: function (value) {
      if (!value)
        return;
      this.dataObj.appData.problemStreetId = value.value;
      if (this.dataObj.appData.problemStreetId > 0)
        this.getStreetAddresses();
    },
    problemStreetAddress: function (value) {
      if (!value)
        return;
      this.dataObj.appData.problemStreetAddressId = value.value;
    },
    groupCode: function (value) {
      if (!value)
        return;
      this.dataObj.appData.groupCodeId = value.value;
    },
    substation: function (value) {
      if (!value)
        return;
      this.dataObj.appData.substationId = value.value;
    },
    problemLogDate: function (val) {
      this.dataObj.appData.applicationDateTime = moment(val, "DD/MM/YYYY").add(1, 'days');
    },
    problemLogDateTime: function (val) {
      this.dataObj.appData.applicationDateTime = moment(val).format();
    },
    gMapDialog: function (value) {
      if (!value && !this.dataObj.readOnly) {
        this.dataObj.appData.locationY = parseFloat(this.gMapData.gMapPosition.lat);
        this.dataObj.appData.locationX = parseFloat(this.gMapData.gMapPosition.lng);
      }
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_problem_log_updated', this.init);
    this.$root.$on('omproblemlog.validation.errors', this.validateActivity);
    this.init();
    setTimeout(() => {
      this.unwatchTown = this.$watch('town', this.townWatcher);
      this.$watch('township', this.townshipWatcher);
      this.$watch('complainType', this.complainTypeWatcher);
      this.$watch('serviceType', this.serviceTypeWatcher);
      this.$watch('station', this.stationWatcher);
    }, 1000);
  },
  methods: {
    showcompleteTownshipsListAction(value) {
      if (value)
        this.allTownships = [...this.dataObj.appData.allTownships];
      else
        this.allTownships = [...this.dataObj.appData.townships];

      this.townWatcher({ value: this.dataObj.appData.townId });
    },
    stationWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.stationId = value.value;
      this.substations = this.allSubstations.filter(p => p.group && p.group.name === value.value.toString());
      if (value.value === 0)
        this.substations = this.allSubstations;
    },
    townWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.townId = value.value;

      if (value.value < 0)
        this.townships = [...this.allTownships];
      else
        this.townships = [...this.allTownships.filter(p => p.group && p.group.name === value.value.toString())];

      this.township = null;
      if (value.value === 0)
        this.townships = [...this.allTownships];
    },
    townshipWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.townshipId = value.value;
      if (this.dataObj.appData.townshipId > 0) {
        this.getStreets();
        if (value.group && this.dataObj.appData.towns.filter(p => p.value === value.group.id) && this.dataObj.appData.towns.filter(p => p.value === value.group.id).length > 0) {
          this.unwatchTown();
          this.town = this.dataObj.appData.towns.filter(p => p.value === value.group.id)[0];
          this.dataObj.appData.townId = this.town.value;
          this.unwatchTown = this.$watch('town', this.townWatcher);
        }
      }
      if (this.dataObj.appData.townshipToStation && this.dataObj.appData.isStationByServiceType === false) {
        var stationId = this.dataObj.appData.townshipToStation[value.value];
        if (stationId >= 0) {
          const newStation = this.stations.filter(p => p.value === stationId.toString()) && this.stations.filter(p => p.value === stationId.toString()).length > 0 ? this.stations.filter(p => p.value === stationId.toString())[0] : null;
          if (newStation) {
            this.station = newStation;
            this.stationId = this.station.value;
          }
        }
      }
    },
    serviceTypeWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.serviceTypeId = value.value;
      if (this.dataObj.appData.serviceTypeToStation && this.dataObj.appData.isStationByServiceType === true) {
        var stationId = this.dataObj.appData.serviceTypeToStation[value.value];
        if (stationId) {
          const newStation = this.stations.filter(p => p.value === stationId.toString()) && this.stations.filter(p => p.value === stationId.toString()).length > 0 ? this.stations.filter(p => p.value === stationId.toString())[0] : null;
          if (newStation) {
            this.station = newStation;
            this.stationId = this.station.value;
          }
        }
      }
    },
    complainTypeWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.complainTypeId = value.value;
      if (this.dataObj.appData.employeeServiceTypeId && this.dataObj.appData.employeeServiceTypeId > 0)
        return;
      var serviceTypeId;
      if (this.dataObj.appData.complainTypeToServiceType) {
        serviceTypeId = this.dataObj.appData.complainTypeToServiceType[value.value];
        if (serviceTypeId) {
          const newServiceType = this.serviceTypes.filter(p => p.value === serviceTypeId.toString()) && this.serviceTypes.filter(p => p.value === serviceTypeId.toString()).length > 0 ? this.serviceTypes.filter(p => p.value === serviceTypeId.toString())[0] : null;
          if (newServiceType)
            this.serviceType = newServiceType;
        }
      }
    },
    validateActivity() {
      this.bOnValidate = true;
      setTimeout(() => {
        var xEl = document.getElementsByClassName('activity-field-error');
        if (xEl.length > 0)
          xEl[0].scrollIntoView({ behavior: 'smooth', block: 'end' });
      }, 100);
    },
    init() {
      Vue.nextTick(() => {
        this.problemLogDate = moment(this.dataObj.appData.applicationDateTime).format('DD/MM/YYYY');
        this.problemLogTime = moment(this.dataObj.appData.startTime).format('HH:mm:ss');
        this.problemLogDateTime = this.dataObj.appData.applicationDateTime; //moment(this.dataObj.appData.applicationDateTime).format();
        this.appId = this.dataObj.appId;

        this.groupCodes = this.dataObj.appData.groupCodes;
        if (this.groupCodes && this.groupCodes.length > 0)
          this.groupCode = this.groupCodes.filter(p => p.value == this.dataObj.appData.groupCodeId)[0];
        this.problemStreetAddresses = this.dataObj.appData.problemStreetAddresses;
        if (this.problemStreetAddresses && this.problemStreetAddresses.length > 0)
          this.problemStreetAddress = this.problemStreetAddresses.filter(p => p.value == this.dataObj.appData.problemStreetAddressId)[0];
        this.problemStreets = this.dataObj.appData.problemStreets;
        if (this.problemStreets && this.problemStreets.length > 0)
          this.problemStreet = this.problemStreets.filter(p => p.value == this.dataObj.appData.problemStreetId)[0];
        this.serviceTypes = this.dataObj.appData.serviceTypes;
        if (this.serviceTypes && this.serviceTypes.length > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.serviceTypeId)[0];
        this.serviceTypeToStation = this.dataObj.appData.serviceTypeToStation;

        if (this.$store.getters.getUserProfile.isFieldWorker) 
          this.stations = this.dataObj.appData.stations.filter(p => p.value == this.dataObj.appData.stationId);
        else
          this.stations = this.dataObj.appData.stations;

        if (this.stations && this.stations.length > 0) {
          this.station = this.stations.filter(p => p.value == this.dataObj.appData.stationId)[0];
          this.stationId = this.station.value;
        }
      
        this.substations = this.dataObj.appData.substations;
        this.allSubstations = this.dataObj.appData.substations;
        if (this.substations && this.substations.length > 0) {
          this.substation = this.substations.filter(p => p.value == this.dataObj.appData.substationId)[0];
          this.substationId = this.substation.value;
        }

        this.towns = this.dataObj.appData.towns;
        if (this.towns && this.towns.length > 0) {
          this.town = this.towns.filter(p => p.value == this.dataObj.appData.townId)[0];

          if (!this.town)
            this.town = this.towns[0];
        }

        this.settlements = this.dataObj.appData.settlements;
        if (this.settlements && this.settlements.length > 0)
          this.settlement = this.settlements.filter(p => p.value == this.dataObj.appData.settlementId)[0];

        if (this.dataObj.appData.employeeServiceTypeId && this.dataObj.appData.employeeServiceTypeId > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.employeeServiceTypeId)[0];

        this.complainTypes = this.dataObj.appData.complainTypes;
        if (this.complainTypes && this.complainTypes.length > 0) 
          this.complainType = this.complainTypes.filter(p => p.value == this.dataObj.appData.complainTypeId)[0];

        if (!this.dataObj.appData.omAllowServTypeSelNoLinkFaultCode && this.serviceType && this.serviceType.value > -1)
            this.complainTypes = this.dataObj.appData.complainTypes.filter(p => p.group.id === this.serviceType.value);

        this.allTownships = [...this.dataObj.appData.townships];

        this.townWatcher(this.town);
        let temp = this.allTownships.filter(t => t.value == this.dataObj.appData.townshipId);       

        if (temp && temp.length > 0) {
          this.township = temp[0];
          this.townshipWatcher(this.township);
        }
        else {
          temp = this.dataObj.appData.allTownships.filter(t => t.value == this.dataObj.appData.townshipId); 

          if (temp && temp.length > 0) {
            this.showcompleteTownshipsList = true;
            this.township = temp[0];
            this.townshipWatcher(this.township);
          }
        }
      });
    },
    showMap() {
      this.gMapData.gMapPosition.lat = parseFloat(this.dataObj.appData.locationY);
      this.gMapData.gMapPosition.lng = parseFloat(this.dataObj.appData.locationX);

      //disable location change
      this.gMapData.readOnly = this.dataObj.readOnly;
      this.gMapData.bDraggable = !this.dataObj.readOnly;
      this.gMapData.bClickable = !this.dataObj.readOnly;

      this.gMapData.bEditLocation = true;
      this.$root.$emit('gmap_location_updated');
    },
    onTimeChanged(val) {
      this[val.var] = val.time;
    },
    setSelectedComplainType(code) {
      console.log(code);
    },
    setSelectedSTypes(code) {
      console.log(code);
    },
    setSelectedGroupCode(code) {
      console.log(code);
    },
    setSelectedStation(code) {
      console.log(code);
    },
    setSelectedSubstations(code) {
      console.log(code);
    },
    setSelectedTown(code) {
      console.log(code);
    },
    setSelectedTownship(code) {
      console.log(code);
    },
    setSelectedSettlement(code) {
      console.log(code);
    },
    getStreets() {
      var parameters = {
        townshipId: this.dataObj.appData.townshipId,
        streetId: null,
        page: 1,
        pageSize: 1000,
        //streetId: this.dataObj.appData.problemStreetId === 0 ? null : this.dataObj.appData.problemStreetId,
      };
      this.$store.state.notifier.asyncBlock(
        axios.get('/OmActivityBase/GetStreets', { params: parameters }),
        response => {
          if (response.status == 200) {
            this.problemStreets = response.data;
            if (this.problemStreets && this.problemStreets.length > 0)
              this.problemStreet = this.problemStreets.filter(p => p.value == this.dataObj.appData.problemStreetId)[0];
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Loading Problem Streets'
      );
    },
    getStreetAddresses() {
      var parameters = {
        streetId: this.dataObj.appData.problemStreetId,
        streetAddressId: null,
        page: 1,
        pageSize: 1000,
        //StreetAddressId: this.dataObj.appData.problemStreetAddressId === 0 ? null : this.dataObj.appData.problemStreetAddressId,
      };
      this.$store.state.notifier.asyncBlock(
        axios.get('/OmActivityBase/GetStreetAddresses', { params: parameters }),
        response => {
          if (response.status == 200) {
            this.problemStreetAddresses = response.data;
            if (this.problemStreetAddresses && this.problemStreetAddresses.length > 0)
              this.problemStreetAddress = this.problemStreetAddresses.filter(p => p.value == this.dataObj.appData.problemStreetAddressId)[0];
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Loading Street Addresses'
      );
    },
    getElements(elementTypeId) {
      var parameter = {
        FilterByCurrentLocation: false,
        ElementTypeId: elementTypeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: { pageSize: 1000, total: 0, page: 1 }
      };
      this.$store.state.notifier.asyncBlock(
        axios.post('/Element/GetElements', parameter),
        response => {
          if (response.status == 200) {
            response.data.items.forEach(item =>
              item.fullname = item.name + (item.externalRef && item.externalRef.length > 0 ? " - " + item.externalRef : "")
            );
            this.elements = response.data.items;
            this.elementKey++;
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Loading Elements'
      );
    },
  },

}

